<script setup lang="ts">
import { AppButton, AppConfirmationModal, SemboOopsImage } from '@libs/ui';

interface ExternalErrorModalEmits {
  (eventName: 'build-a-new-trip'): void;
  (eventName: 'try-again'): void;
}

const emit = defineEmits<ExternalErrorModalEmits>();
</script>

<template>
  <AppConfirmationModal
    :show-close-button="false"
    class="external-error-modal"
    :close-button-aria-label="$t('a11y.close_panel')"
  >
    <template #title>
      <div class="external-error-modal-title">
        {{ $t('planner.external_errors.oops') }}
      </div>
    </template>

    <template #content>
      <div class="external-error-modal-content">
        <SemboOopsImage class="oops-image" />
        <div class="message">
          {{ $t('planner.external_errors.try_again_or_new_trip') }}
        </div>

        <div class="actions">
          <AppButton
            type="secondary"
            state="enabled"
            size="large"
            :wide="true"
            @click="emit('build-a-new-trip')"
          >
            {{ $t('planner.external_errors.build_a_new_trip') }}
          </AppButton>
          <AppButton
            type="primary"
            state="enabled"
            size="large"
            :wide="true"
            @click="emit('try-again')"
          >
            {{ $t('planner.external_errors.try_again') }}
          </AppButton>
        </div>
      </div>
    </template>
  </AppConfirmationModal>
</template>

<style scoped lang="scss">
.external-error-modal {
  .external-error-modal-title {
    color: var(--color-neutral-70);
    @include font-heading-5;
  }

  .external-error-modal-content {
    .oops-image {
      margin-top: var(--spacing-8);
      margin-bottom: var(--spacing-24);
    }

    .message {
      margin-bottom: var(--spacing-24);
    }

    .actions {
      border-top: 1px solid var(--color-neutral-30);
      padding-top: var(--spacing-24);

      display: flex;
      gap: var(--spacing-24);

      @include for-less-or-equal-than-599-px {
        flex-direction: column;
      }
    }
  }
}
</style>
